//
// Generated class SupplierOrderPaymentTransaction
//

/// <reference path="SupplierOrderPaymentTransaction_ManagedObject.ts" />

class SupplierOrderPaymentTransaction extends SupplierOrderPaymentTransaction_ManagedObject
{

}
